import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJBAuth } from '../auth';

export default function SeekerGuard({ children }) {
  const { token, role, loading } = useJBAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && (!token || role !== 'job_seeker')) {
      navigate('/seeker/login', { replace: true });
    }
  }, [token, role, loading, navigate]);

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'60vh', color:'#5a6373', fontFamily:'Inter,sans-serif' }}>
        Loading…
      </div>
    );
  }

  if (!token || role !== 'job_seeker') return null;
  return children;
}
